import { parseStringBoolean } from '@wix/package-picker-common';
import * as React from 'react';
export const useQueryParams = () => {
  return React.useMemo(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const siteGuid = searchParams.get('siteGuid') ?? undefined;
    const isChangePlanString = searchParams.get('isChangePlan');
    const isChangePlan = isChangePlanString ? parseStringBoolean(isChangePlanString) ?? false : false;
    return {
      siteGuid,
      isChangePlan
    };
  }, []);
};
//# sourceMappingURL=useQueryParams.js.map